import type React from 'react';
import type { CustomerService } from '../../../types';
import Translation from '../../../../../general/Translation/Translation';
import Button from '../../../../../general/Button/Button';
import useTranslate from '../../../../../general/Translation/hooks/UseTranslate';

interface ServiceProps {
  contactInfo: CustomerService;
}

const Contact: React.FC<ServiceProps> = ({ contactInfo }) => {
  const translate = useTranslate();
  const openingTimeException = translate('contact', 'opening_time_exception', {
    strict: false,
  });
  const serviceAvailableAt = translate('contact', 'service_available_at');
  const openingTimes = translate('contact', 'opening_times');

  const detailText = `${serviceAvailableAt} ${openingTimes}${openingTimeException}`;

  return (
    <div className="is-col-3 is-col-1-lg">
      <div
        id="openinghours"
        className="block block--boxed block--fluid block--grey"
      >
        <div className="content">
          <span className="eyebrow">
            <Translation
              pageString="chunk.gifthelp"
              stringId="klantenservice"
            />
          </span>
          <h3 className="h4">
            <Translation
              pageString="chunk.gifthelp"
              stringId="contact_us"
            />
          </h3>
          <div
            className="p"
            dangerouslySetInnerHTML={{ __html: detailText }}
          />
          <Button
            href={`tel:${contactInfo.customerServicePhoneNumber}`}
            icon="fa-phone"
            isSplit
            isGhost
            className="mt-8"
          >
            {contactInfo.customerServicePhoneNumberFormatted}
          </Button>
          <Button
            href={`mailto:${contactInfo.customerServiceEmailAddress}`}
            icon="fa-envelope"
            isSplit
            isGhost
            className="mt-4"
          >
            {contactInfo.customerServiceEmailAddress}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Contact;
